import { g } from '../global-constants';

const getTrackingInfoForResult = (type, isDefaultResult, title, facets) => ({
	element: `${isDefaultResult ? 'default' : 'autocomplete'} ${type} result`,
	elementCTA: type === g.INVENTORY && !isDefaultResult ? facets : title,
	fieldValue: title,
	result: 'text search form submitted'
});
export default getTrackingInfoForResult;
